import { TimeFrame } from "charts/src/types/chart";
import { useSearchParams } from "next/navigation";

import { getDefaultDateOption } from "@/features/analysis/components/key-metrices-charts/data/date-options";
import { DateOption } from "@/utils/date-options";

const DEFAULT_TIME_FRAME = "Q";

export const useTimeFrameParams = (
  defaultTimeFrame: TimeFrame = DEFAULT_TIME_FRAME
) => {
  const searchParams = useSearchParams();
  const timeFrame =
    (searchParams.get("timeFrame") as TimeFrame) ?? defaultTimeFrame;
  const dateOption =
    (searchParams.get("dateOption") as DateOption) ??
    getDefaultDateOption(timeFrame);

  return {
    timeFrame,
    dateOption,
  };
};
